import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("updateThemeSmartScheduleShift", function updateThemeSmartScheduleShift(theme: string) {
    if (shiftEditorViewState().smartScheduleShift) {
        shiftEditorViewState().smartScheduleShift.theme = theme;
    }
});